<h1 class="center">
	Confirmation de la commande du {{ dateLivraison | date: 'EEEE dd/MM/yyyy': 'fr'}}
</h1>
<div class="container">
	<div *ngIf="loading; else commandeConfirmTemplate" class="flex justify-center">
		<mat-spinner></mat-spinner>
	</div>
	<ng-template #commandeConfirmTemplate>
		<table class="styled-table">
			<thead>
				<tr>
					<th>Article</th>
					<th>Quantité</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let data of confirmData">
					<td>{{ data.article.designation }}</td>
					<td>{{ data.quantite ?? "Non renseignée" }}</td>
				</tr>
			</tbody>
		</table>

		<div class="buttons-center">
			<button mat-raised-button type="button" routerLink="../edit-commande" [queryParams]="{id: commandeId}"
				(click)="modifier()" *ngIf="isCommandeLingerie">
				Modifier
			</button>
			<button mat-raised-button type="button" routerLink="../edit" [queryParams]="{id: commandeId}"
				(click)="modifier()" *ngIf="!isCommandeLingerie">
				Modifier
			</button>
			<button matTooltip="Les quantités seront passées à 0, il n'y aura pas de livraison." mat-raised-button
				color="primary" type="button" (click)="pasDeCommande()" *ngIf="!isCommandeLingerie">
				Pas de commande
			</button>
			<button mat-raised-button color="primary" type="button" (click)="transmettre()"
				[disabled]="!isTransmissible">Transmettre</button>
		</div>
	</ng-template>
</div>